module.exports = __webpack_public_path__ + "static/media/Interior.f376e096.jpg";